import { PasswordInput, PasswordInputProps } from "@mantine/core"

const CustomPasswordInput = (props: PasswordInputProps) => (
  <PasswordInput
    {...props}
  />
)

export default CustomPasswordInput;